import React, { useState, useEffect, useRef } from "react";
import "./comment.css";
import { useInView } from "react-intersection-observer";
import { motion } from 'framer-motion'

export default function Comment() {
    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState({ user: "", text: "", rating: 0 });
    const [page, setPage] = useState(1);
    const [totalComments, setTotalComments] = useState(0); // برای ذخیره تعداد کل کامنت‌ها
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [captchaValue, setCaptchaValue] = useState("");
    const [userCaptcha, setUserCaptcha] = useState("");
    const captchaCanvasRef = useRef(null);

    const loadComments = async () => {
        try {
            const response = await fetch(`http://185.164.73.170:5001/api/comments?status=approved`);
            const data = await response.json();
            setComments(data.slice(0, page * 5));
            setTotalComments(data.length); // ذخیره تعداد کل کامنت‌ها
        } catch (error) {
            console.error("Error fetching comments:", error);
        }
    };

    const generateCaptcha = () => {
        const randomNumber = Math.floor(10000 + Math.random() * 90000).toString();
        setCaptchaValue(randomNumber);
        return randomNumber;
    };

    const drawCaptcha = (captchaText) => {
        const canvas = captchaCanvasRef.current;
        const context = canvas.getContext("2d");
        context.clearRect(0, 0, canvas.width, canvas.height);

        context.font = "bold 28px Arial";
        context.fillStyle = "#f0f0f0";
        context.fillRect(0, 0, canvas.width, canvas.height);

        const startX = 15;
        const letterSpacing = 20;

        for (let i = 0; i < captchaText.length; i++) {
            const char = captchaText[i];
            const x = startX + i * letterSpacing;
            const y = 35;
            const rotation = Math.random() * 0.1 - 0.05;

            context.save();
            context.translate(x, y);
            context.rotate(rotation);
            context.fillStyle = "#333";
            context.fillText(char, 0, 0);
            context.restore();
        }

        context.strokeStyle = "#888";
        for (let i = 0; i < 3; i++) {
            context.beginPath();
            context.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
            context.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
            context.stroke();
        }
    };

    useEffect(() => {
        loadComments();
        const initialCaptcha = generateCaptcha(); // Generate captcha on initial load
        drawCaptcha(initialCaptcha); // Draw initial captcha
    }, [page]);

    const submitComment = async () => {
        if (!newComment.user.trim() || !newComment.text.trim() || newComment.rating < 1) {
            setError("لطفا تمامی فیلدها را پر کنید و امتیاز 1 تا 5 را وارد نمایید.");
            setSuccess("");
            return;
        }

        if (userCaptcha !== captchaValue) {
            setError("کد کپچا نادرست است.");
            setSuccess("");
            return;
        }

        try {
            await fetch(`http://185.164.73.170:5001/api/comments`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(newComment),
            });
            setNewComment({ user: "", text: "", rating: 0 });
            setError("");
            setSuccess("نظر شما با موفقیت ارسال شد!");
            setUserCaptcha("");
            const newCaptcha = generateCaptcha(); // Regenerate captcha after submission
            drawCaptcha(newCaptcha); // Draw the new captcha
            loadComments(); // بارگذاری مجدد کامنت‌ها پس از ارسال
        } catch (error) {
            console.error("Error submitting comment:", error);
            setError("ارسال نظر با مشکل مواجه شد، لطفا دوباره امتحان کنید.");
            setSuccess("");
        }
    };

    const handleStarClick = (rating) => {
        setNewComment({ ...newComment, rating });
        setError(""); // Clear any previous error messages
    };
    const { ref: ref1 , inView: inView1 } = useInView({threshold: 0.1 , triggerOnce: true})
    const { ref: ref2 , inView: inView2 } = useInView({threshold: 0.1 , triggerOnce: true})
    return (
        <div className="commentbox">
            <motion.div className="addcomment" ref={ref1} initial={{ opacity: 0 , y: 50}} animate={ inView1 ? { opacity: 1 , y: 0} : {}} transition={{duration: 0.5}}>
                <h2>نظر خود را ثبت کنید</h2>
                <input
                    type="text"
                    placeholder="نام و نام خانوادگی"
                    value={newComment.user}
                    onChange={(e) => setNewComment({ ...newComment, user: e.target.value })}
                />
                <textarea
                    placeholder="نظر خود را بنویسید"
                    value={newComment.text}
                    onChange={(e) => setNewComment({ ...newComment, text: e.target.value })}
                />
                <div className="stars">
                    {[1, 2, 3, 4, 5].map((star) => (
                        <span
                            key={star}
                            className={`star ${star <= newComment.rating ? "selected" : ""}`}
                            onClick={() => handleStarClick(star)}
                        >
                            ⭐
                        </span>
                    ))}
                </div>
                {newComment.rating > 0 && <p className="rating-info">امتیاز انتخاب‌شده: {newComment.rating} ⭐</p>}

                <div className="captcha">
                    <canvas ref={captchaCanvasRef} width="120" height="50"></canvas>
                    <input
                        type="text"
                        placeholder="کد کپچا را وارد کنید"
                        value={userCaptcha}
                        onChange={(e) => setUserCaptcha(e.target.value)}
                    />
                </div>
                <button onClick={submitComment}>ثبت نظر</button>
                {error && <p className="error">{error}</p>}
                {success && <p className="success">{success}</p>}
            </motion.div>
            <motion.div className="listcomment" ref={ref2} initial={{ opacity: 0 , y: 58}} animate={ inView2 ? { opacity: 1 , y: 0} : {}} transition={{duration: 0.5}}>
                <h2>نظرات کاربران</h2>
                {comments.map((comment) => (
                    <div key={comment.id} className="comments">
                        <h3>{comment.user}</h3>
                        <p>{comment.text}</p>
                        <p>امتیاز: {"⭐".repeat(comment.rating)}</p>
                    </div>
                ))}
                {comments.length < totalComments && ( // فقط اگر هنوز نظرات بیشتری وجود دارد دکمه را نشان می‌دهیم
                    <button onClick={() => setPage(page + 1)}>مشاهده نظرات بیشتر</button>
                )}
            </motion.div>
        </div>
    );
}
